export default "__VITE_ASSET__BnaZsD0Q__"